import { FormEvent, useEffect, useState } from "react";
import { admin, SenderBlock } from "../../api/client";
import { fmtDate, PageHeader } from "./common";

export default function Blocklist() {
  const [rows, setRows] = useState<SenderBlock[]>([]);
  const [matchType, setMatchType] = useState<SenderBlock["match_type"]>("sender_domain");
  const [pattern, setPattern] = useState("");
  const [notes, setNotes] = useState("");
  const [error, setError] = useState<string | null>(null);

  const load = () => admin.blocklist().then(setRows).catch((e) => setError(e.message));
  useEffect(() => {
    load();
  }, []);

  async function add(e: FormEvent) {
    e.preventDefault();
    setError(null);
    try {
      await admin.addBlock({ match_type: matchType, pattern, notes: notes || null });
      setPattern("");
      setNotes("");
      load();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Could not add");
    }
  }

  async function remove(b: SenderBlock) {
    await admin.removeBlock(b.id);
    load();
  }

  return (
    <div className="page">
      <PageHeader
        title="Sender blocklist"
        sub="Emails from these senders are skipped before any AI call, for every user. Use it for noisy newsletters that slip past the keyword prefilter."
      />
      {error && <div className="page-error">{error}</div>}
      <form onSubmit={add} className="filter-bar">
        <select value={matchType} onChange={(e) => setMatchType(e.target.value as SenderBlock["match_type"])}>
          <option value="sender_domain">Domain (includes subdomains)</option>
          <option value="sender_email">Exact email address</option>
        </select>
        <input required placeholder={matchType === "sender_domain" ? "news.example.com" : "promo@example.com"}
          value={pattern} onChange={(e) => setPattern(e.target.value)} />
        <input placeholder="Note (optional)" value={notes} onChange={(e) => setNotes(e.target.value)} />
        <button type="submit" className="btn btn-primary btn-sm">Block</button>
      </form>
      {rows.length === 0 ? (
        <div className="page-empty">No blocked senders.</div>
      ) : (
        <table className="data-table">
          <thead>
            <tr><th>Type</th><th>Pattern</th><th>Note</th><th>Added</th><th /></tr>
          </thead>
          <tbody>
            {rows.map((b) => (
              <tr key={b.id}>
                <td>{b.match_type === "sender_domain" ? "Domain" : "Email"}</td>
                <td><code>{b.pattern}</code></td>
                <td>{b.notes}</td>
                <td>{fmtDate(b.created_at)}</td>
                <td style={{ textAlign: "right" }}><button className="btn btn-ghost btn-sm" onClick={() => remove(b)}>Remove</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
